import { useIntl } from 'react-intl';

export const useProductivityFieldLabels = () => {
  const intl = useIntl();

  return {
    'cataloging_productivity_view.first_name': intl.formatMessage({
      id: 'ui-reports.productivityReports.fields.firstName',
      defaultMessage: 'First Name',
    }),
    'cataloging_productivity_view.last_name': intl.formatMessage({
      id: 'ui-reports.productivityReports.fields.lastName',
      defaultMessage: 'Last Name',
    }),
    'cataloging_productivity_view.instance_created_by': intl.formatMessage({
      id: 'ui-reports.productivityReports.fields.createdBy',
      defaultMessage: 'Created By',
    }),
    'cataloging_productivity_view.instances_created': intl.formatMessage({
      id: 'ui-reports.productivityReports.fields.instancesCreated',
      defaultMessage: 'Instances Created',
    }),
    'cataloging_productivity_view.holdings_created': intl.formatMessage({
      id: 'ui-reports.productivityReports.fields.holdingsCreated',
      defaultMessage: 'Holdings Created',
    }),
    'cataloging_productivity_view.items_created': intl.formatMessage({
      id: 'ui-reports.productivityReports.fields.itemsCreated',
      defaultMessage: 'Items Created',
    }),
  };
};
